/**
 * 从多种分页响应格式提取 { list, total, page, size }
 */
export function extractPagePayload(res) {
  const body = res && res.data
  const d = body && body.data !== undefined ? body.data : body
  if (!d || typeof d !== 'object') {
    return { list: [], total: 0, page: 1, size: 25 }
  }
  let list = d.list || d.records || d.content || d.items || []
  if (!Array.isArray(list)) list = []
  const total =
    d.total != null
      ? Number(d.total)
      : d.totalElements != null
        ? Number(d.totalElements)
        : list.length
  const page =
    d.current != null
      ? Number(d.current)
      : d.page != null
        ? Number(d.page)
        : 1
  const size =
    d.size != null
      ? Number(d.size)
      : d.pageSize != null
        ? Number(d.pageSize)
        : list.length
  return {
    list,
    total: Number.isFinite(total) ? total : 0,
    page: Number.isFinite(page) ? page : 1,
    size: Number.isFinite(size) ? size : 25
  }
}
